import React, { useEffect, useState } from "react";
import { postQrCodeByStatus } from "../../services/QrCode/postQrCodeByStatus";
import { OrderDeliveryVerificationOTP, OrderDeliveryVerificationRequest } from "../../services/OrderDelivery/deliveryOrder";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import SuccessModal from "../SuccessModal";
import { InputText } from "primereact/inputtext";

const AuthCodeCustomerVerifyModal = ({
  authCodeCustomerVerifyModalVisible,
  setAuthCodeCustomerVerifyModalVisible,
  storeCustomerId,
  storeId,
  bookingOrderId,
  mobileNumber,
  customerName,
}) => {
  const [authCodeValue, setAuthCodeValue] = useState("");
  const [isPayNowButtonPressed, setIsPayNowButtonPressed] = useState(false);
  const [readyToDeliveryData, setReadyToDeliveryData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const fetchGetDeliveryQrCode = (data) => {
    postQrCodeByStatus(storeCustomerId, storeId, bookingOrderId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setReadyToDeliveryData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };
  useEffect(() => {
    // Filter items with status equal to 'OUT_FOR_DELIVERY'
    const data = {
      status: ["OUT_FOR_DELIVERY"],
    };
    fetchGetDeliveryQrCode(data);
  }, []);

  // Function to reset the state variables
  const resetFields = () => {
    setAuthCodeValue("");
    setAuthCodeError("");
    // ... (reset other fields if needed)
  };

  useEffect(() => {
    // Do something when modal is closed
    if (!authCodeCustomerVerifyModalVisible) {
      resetFields();
    }
  }, [authCodeCustomerVerifyModalVisible]);

  // Initialize a state variable for storing pickup requests
  const [authCodeError, setAuthCodeError] = useState("");

  const [focusedField, setFocusedField] = useState("");

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  const handleAuthCodeChange = (text) => {
    setAuthCodeValue(text);
  };

  const handleResendAuthCode = () => {

    const VerificationRequestData = {
      orderId: bookingOrderId,
      receiverName: customerName,
      mobileNo: mobileNumber,
      otp: '',
    };

    OrderDeliveryVerificationRequest(
      storeCustomerId,
      storeId,
      bookingOrderId,
      VerificationRequestData
    )
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res.status === true) {
            setModalVisible(true);
            setModalStatus("success");
            setModalText(Res.message);
            setAuthCodeCustomerVerifyModalVisible(false);
          } else {
            setModalVisible(true);
            setModalStatus("Failed");
            setModalText(Res.message);
            setAuthCodeCustomerVerifyModalVisible(false);
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  }

  const handleCollectPayment = () => {
    if (authCodeValue === "") {
      setAuthCodeError("Please Enter Auth Code");
    } else {
      setAuthCodeError("");
      if (!isPayNowButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsPayNowButtonPressed(true);
        const VerificationData = {
          orderId: bookingOrderId,
          receiverName: customerName,
          mobileNo: mobileNumber,
          otp: authCodeValue,
        };
        OrderDeliveryVerificationOTP(
          storeCustomerId,
          storeId,
          bookingOrderId,
          VerificationData
        )
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              if (Res.status === true) {
                setModalVisible(true);
                setModalStatus("success");
                setModalText("Customer Verify Successfully");
                setAuthCodeCustomerVerifyModalVisible(false);
                setIsPayNowButtonPressed(false);
              } else {
                setModalVisible(true);
                setModalStatus("Failed");
                setModalText("Invalid Auth Code");
                setAuthCodeCustomerVerifyModalVisible(false);
                setIsPayNowButtonPressed(false);
              }
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      }
    }
  };

  const handleModalClose = () => {
    setAuthCodeCustomerVerifyModalVisible(false);
    setIsPayNowButtonPressed(false);
    resetFields();
  };


  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={authCodeCustomerVerifyModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!authCodeCustomerVerifyModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                 "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                <img
                  src={
                    "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                  }
                />
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Verify Account
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div className="mt-3 mx-4">
              <div>
                <p>Auth Code</p>
                <InputText
                  className="w-full text-xl h-3rem border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  value={authCodeValue}
                  onChange={(e) => handleAuthCodeChange(e.target.value)}
                  onFocus={() => handleFocus("authCode")}
                  onBlur={handleBlur}
                  keyboardType="numeric"
                />
              </div>
              {authCodeError !== "" && <p>{authCodeError}</p>}
            </div>
            <div className="d-flex flex-row flex justify-content-end">
                  <p style={{alignSelf:"center", color:"blue"}}>Resend Auth Code</p>
                  <Button
              className="mx-4 border-round-xl px-2 py-2"
              onClick={handleResendAuthCode}
              disabled={isPayNowButtonPressed}
            >
              <p className=" w-full text-xl font-semibold flex justify-content-center">
                Resend
              </p>
            </Button>
            </div>

            <Button
              className="mt-1 mb-3 mx-4 border-round-xl "
              onClick={handleCollectPayment}
              disabled={isPayNowButtonPressed}
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Verify Now
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};
export default AuthCodeCustomerVerifyModal;
